<div class="banner-info-container">
    <div class="container">
      <div class="pt-5">
        <h1 class="pb-3">Empowering Our Partners with GeM Portal Assistance</h1>
          <img loading="lazy" src="{{environment?.blobUrl}}/assets/images/gem/GeM-support-flyer.webp" alt="GEM Support Flyer | Luminous" class="h-100" (load)="imageLoaded()">
      </div>
    </div>
  </div>
  